(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/betslip/assets/javascripts/betslips/standard.js') >= 0) return;  svs.modules.push('/components/tipsen/betslip/assets/javascripts/betslips/standard.js');
"use strict";

const {
  useSelector
} = ReactRedux;
const {
  useContext
} = React;
const {
  BetslipContext
} = svs.components.tipsen.betslip;
const {
  HedgesView,
  HedgesXsmallView,
  RowsXsmallView,
  RowsView
} = svs.components.tipsen.betslip.views;
const {
  selectEngineDefinition
} = svs.components.tipsen.engine.selectors;
const {
  EventTypeId
} = svs.components.sportinfo.common.constants;
const Standard = () => {
  const {
    isExtraSmall
  } = useContext(BetslipContext);
  const currentEngine = useSelector(selectEngineDefinition);
  const isGoalCount = currentEngine.outcomes.eventTypeId === EventTypeId.GOAL_COUNT;
  if (isExtraSmall) {
    return isGoalCount ? React.createElement(RowsXsmallView, null, "Standard") : React.createElement(HedgesXsmallView, null, "Standard");
  }
  return isGoalCount ? React.createElement(RowsView, {
    icon: "enkelrader-tur"
  }, React.createElement("span", null, "Standard")) : React.createElement(HedgesView, {
    icon: "enkelrader-tur"
  }, React.createElement("span", null, "Standard"));
};
setGlobal('svs.components.tipsen.betslip.betslips.Standard', Standard);

 })(window);